import { render, staticRenderFns } from "./AddOrUpdateInstall.vue?vue&type=template&id=4c45407c&scoped=true"
import script from "./AddOrUpdateInstall.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateInstall.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateInstall.vue?vue&type=style&index=0&id=4c45407c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c45407c",
  null
  
)

export default component.exports